import { Routes } from '@angular/router';
import { AuthGuard } from '../../../shared/authguards/auth.guard';
import { paidCustomerGuard } from '../../../shared/authguards/paid-customer.guard';
import { PaidActiveTimeGuard } from '../../../shared/authguards/paid-active-time-guard.service';
import { reviewDraftGuard } from '../../../shared/authguards/review-draft.guard';

export const PAID_SICK_LEAVE_ROUTES: Routes = [
  {
    path: "paid-sick-leave",
    loadComponent: () => import("./paid-sick-leave.component")
      .then(m => m.PaidSickLeaveComponent),
    canActivate: [AuthGuard, paidCustomerGuard, PaidActiveTimeGuard],
    data: { title: "pageTitles.paidSickLeave" },
    children: [
      {
        path: "payment-instructions-info",
        loadComponent: () => import("./../payment-instructions-info/payment-instructions-info.component").then(m => m.PaymentInstructionsInfoComponent),
        data: { title: "pageTitles.paymentInstructionsInfo" },
      },
      {
        path: "feedback-info",
        loadComponent: () => import("./../feedback-info/feedback-info.component").then(m => m.FeedbackInfoComponent),
        data: { title: "pageTitles.feedbackInfo" },
      },
      {
        path: "review",
        loadComponent: () => import("./paid-sick-leave-review/paid-sick-leave-review.component").then(m => m.PaidSickLeaveReviewComponent),
        canActivate: [reviewDraftGuard],
        data: { title: "pageTitles.paidSickLeave" },
      },
    ],
  },
];
